import { AxiosResponse } from 'axios';
import { selectCurrentUser } from '../../../shared/sagas/auth/authSlice';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { BalanceDetailsDTO, Configuration, CreateOneTimePaymentDto, ResidentsApi, PaymentsApi, BankAccountsApi, BankCardsApi, ValidTransactionStatusEnum } from '@inosio/payments-sdk';
import { FeesDTO, TransactionDTO, BankCardTypeDto, CreateBankAccountDTO, BankAccountDTO, CreateBankCardDTO, BankCardDTO } from '@inosio/payments-sdk';
import { UpdateBankAccountDTO, UpdateBankCardDTO, PaymentsConfigDto, ScheduledAutoPayDto } from '@inosio/payments-sdk';
import { CreateScheduledAutoPayDto, UpdateSkipAPDto, ValidRequestMessages, ResidentDTO } from '@inosio/payments-sdk';
import { getBalanceDetails, setBalanceDetails, getTransactionHistory, setTransactionHistory, getPaymentMethods, setPaymentMethods, setResidentDetails } from './residentpaymentsSlice';
import { getResidentDetails, getPaymentFeesByResident, setPaymentFeesByResident, setOneTimePaymentResult } from './residentpaymentsSlice';
import { makeOneTimePayment, setBankCardType, getBankCardType, getCreateBankAccount, setCreateBankAccResponse, setCreateBankCardResponse } from './residentpaymentsSlice';
import { getCreateBankCard, createBankAccountFailed, createCreateBankCardFailed, setUpdateBankAccResponse, getUpdateBankAccount, setUpdateBankCardResponse, getUpdateBankCard } from './residentpaymentsSlice';
import { getDeleteBankAccount, setDeleteBankAccResponse, setDeleteBankCardResponse, getDeleteBankCard, updateBankAccountFailed, updateBankCardFailed, deleteBankCardFailed } from './residentpaymentsSlice';
import { deleteBankAccountFailed, getPaymentConfigs, setgetPaymentConfigs, getCreateRecurringPayment, setCreateRecurringPaymentResponse, getCreateRecurringPaymentFailed, getAutoPays, setGetAutoPays } from './residentpaymentsSlice';
import { setReplaceAutoPayResponse, getReplaceAutoPay, getReplaceAutoPayFailed, setSkipAutoPayFailed, setSkipAutoPayResponse, getSkipAutoPay, getCancelAutoPay, setCancelAutoPayFailed } from './residentpaymentsSlice';
import { setCancelAutoPayResponse, makeOTPfailed, getTransactionHistoryFailed, getBalanceDetailsFailed, getPaymentMethodsFailed, getAutoPaysFailed, getResidentDetailsFailed } from './residentpaymentsSlice';
import { getPaymentMethodsByResidentFailed, getBankCardTypeFailed, getPaymentConfigsFailed, getCancelOTP, setCancelOTPResponse, setCancelOTPFailed, getRefundOTP } from './residentpaymentsSlice';
import { setRefundOTPResponse, setRefundOTPError, setCancelSatusResponse, getCancelStatus, setCancelStatusError } from './residentpaymentsSlice';
import {IpaUserExtended} from '../../../shared/sagas/auth/authSlice';

const { REACT_APP_IPA_BASE_PATH } = process.env;
const apiConfig = new Configuration({ basePath: REACT_APP_IPA_BASE_PATH });

export function requestGetResidentDetails(access_token: string, residentUUID: string) {
  apiConfig.accessToken = access_token;
  const ipaResidentAPI = new ResidentsApi(apiConfig);

  return ipaResidentAPI.findOneResident(residentUUID);
}

export function requestgetPaymentConfigs(access_token: string, residentUUID: string) {
  apiConfig.accessToken = access_token;
  const ipaPaymentsAPI = new PaymentsApi(apiConfig);

  return ipaPaymentsAPI.getPaymentConfigs(residentUUID);
}

export function requestCreateBankAccount(access_token: string, createBankAccountDTO: CreateBankAccountDTO) {
  apiConfig.accessToken = access_token;
  const ipaBankAccountsAPI = new BankAccountsApi(apiConfig);

  return ipaBankAccountsAPI.createBankAccount(createBankAccountDTO);
}

export function requestCreateRecurringPayment(access_token: string, createRecurringPayementDTO: CreateScheduledAutoPayDto) {
  apiConfig.accessToken = access_token;
  const ipaPaymentsAPI = new PaymentsApi(apiConfig);

  return ipaPaymentsAPI.createAutoPayment(createRecurringPayementDTO);
}

export function requestUpdateBankAccount(access_token: string, bankaccountUuid: string, updateBankAccountDTO: UpdateBankAccountDTO) {
  apiConfig.accessToken = access_token;
  const ipaBankAccountsAPI = new BankAccountsApi(apiConfig);

  return ipaBankAccountsAPI.updateBankAccount(bankaccountUuid, updateBankAccountDTO);
}

export function requestReplaceAutoPay(access_token: string, autopayUid: string, replaceAutoPayDto: CreateScheduledAutoPayDto) {
  apiConfig.accessToken = access_token;
  const ipaPaymentsAPI = new PaymentsApi(apiConfig);

  return ipaPaymentsAPI.replaceAutoPayment(autopayUid, replaceAutoPayDto);
}

export function requestDeleteBankAccount(access_token: string, bankaccountUuid: string) {
  apiConfig.accessToken = access_token;
  const ipaBankAccountsAPI = new BankAccountsApi(apiConfig);

  return ipaBankAccountsAPI.deleteBankAccount(bankaccountUuid);
}

export function requestCancelAutoPay(access_token: string, autopayUid: string) {
  apiConfig.accessToken = access_token;
  const ipaPaymentsAPI = new PaymentsApi(apiConfig);

  return ipaPaymentsAPI.cancelAutoPayment(autopayUid);
}

export function requestDeleteBankCard(access_token: string, residentUUID: string) {
  apiConfig.accessToken = access_token;
  const ipaBankCardsAPI = new BankCardsApi(apiConfig);

  return ipaBankCardsAPI.deleteBankCard(residentUUID);
}

export function requestUpdateBankCard(access_token: string, residentUUID: string, updateBankCardDTO: UpdateBankCardDTO) {
  apiConfig.accessToken = access_token;
  const ipaBankCardsAPI = new BankCardsApi(apiConfig);

  return ipaBankCardsAPI.updateBankCard(residentUUID, updateBankCardDTO);
}

export function requestCreateCardAccount(access_token: string, createBankCardDTO: CreateBankCardDTO) {
  apiConfig.accessToken = access_token;
  const ipaBankCardsAPI = new BankCardsApi(apiConfig);

  return ipaBankCardsAPI.createBankCard(createBankCardDTO);
}

export function requestGetBankCardType(access_token: string, cardPrefix: string) {
  apiConfig.accessToken = access_token;
  const ipaBankCardsAPI = new BankCardsApi(apiConfig);

  return ipaBankCardsAPI.getBankCardTypeByBIN(cardPrefix);
}

export function requestGetBalanceDetails(access_token: string, residentUUID: string) {
  apiConfig.accessToken = access_token;
  const ipaPaymentsAPI = new PaymentsApi(apiConfig);

  return ipaPaymentsAPI.getBalanceDetails(residentUUID);
}

export function requestGetTransactionHistory(access_token: string, residentUUID: string) {
  apiConfig.accessToken = access_token;
  const ipaPaymentsAPI = new PaymentsApi(apiConfig);
  return ipaPaymentsAPI.findAllPayments(residentUUID);
}

export function requestGetAutoPays(access_token: string) {
  apiConfig.accessToken = access_token;
  const ipaPaymentsAPI = new PaymentsApi(apiConfig);
  return ipaPaymentsAPI.getAutopays();
}

export function requestGetPaymentMethods(access_token: string, residentUUID: string) {
  apiConfig.accessToken = access_token;
  const ipaPaymentsAPI = new PaymentsApi(apiConfig);
  return ipaPaymentsAPI.getPayMethods(residentUUID);
}

export function requestMakeOneTimePayment(access_token: string, residentUUID: string, createOneTimePaymentDto: CreateOneTimePaymentDto) {
  apiConfig.accessToken = access_token;
  const pmtAPI = new PaymentsApi(apiConfig);

  return pmtAPI.createOneTimePayment(createOneTimePaymentDto);
}

export function requestGetPaymentFeesByResident(access_token: string, residentUUID: string, paymentAmount: number, propertyPayTypeId: number) {
  apiConfig.accessToken = access_token;
  const pmtAPI = new PaymentsApi(apiConfig);

  return pmtAPI.getPaymentFees(residentUUID, paymentAmount, propertyPayTypeId);
}

export function requestSkipAutopay(access_token: string, autopayUid: string, updateSkipAPDto: UpdateSkipAPDto) {
  apiConfig.accessToken = access_token;
  const ipaPaymentsAPI = new PaymentsApi(apiConfig);

  return ipaPaymentsAPI.setAutopaySkipSetting(autopayUid, updateSkipAPDto);
}

// cancel OTP
export function requestCancelOTP(access_token: string, transactionUuid: string, residentUuid: string) {
  apiConfig.accessToken = access_token;
  const ipaPaymentsAPI = new PaymentsApi(apiConfig);

  return ipaPaymentsAPI.cancelOrRefundPayment(transactionUuid, residentUuid, { status: ValidRequestMessages.Cancel });
}

// refund OTP
export function requestRefundOTP(access_token: string, transactionUuid: string, residentUuid: string, message: string) {
  apiConfig.accessToken = access_token;
  const ipaPaymentsAPI = new PaymentsApi(apiConfig);

  return ipaPaymentsAPI.cancelOrRefundPayment(transactionUuid, residentUuid, { status: ValidRequestMessages.Refund, requestMessage: message });
}

// get CancelStatus
export function requestCancelStatus(access_token: string, residentUuid: string, transactionUuid: string) {
  apiConfig.accessToken = access_token;
  const ipaPaymentsAPI = new PaymentsApi(apiConfig);

  return ipaPaymentsAPI.findSpecificPayment(transactionUuid, residentUuid);
}

export function* handleGetResidentDetails() {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<ResidentDTO> = yield call(requestGetResidentDetails, currentUser.accessToken, currentUser.currentProfile.uuid);
    const { data } = response;
    yield put(setResidentDetails({ ...data }));
  } catch (error: any) {
    yield put(getResidentDetailsFailed({ message: error?.response?.data?.message }));
  }
}

export function* handleGetBalanceDetails() {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<BalanceDetailsDTO> = yield call(requestGetBalanceDetails, currentUser.accessToken, currentUser.currentProfile.uuid);
    const { data } = response;
    yield put(setBalanceDetails({ ...data }));
  } catch (error: any) {
    yield put(getBalanceDetailsFailed({ message: error?.response?.data?.message }));
  }
}

export function* handleGetTransactionHistory() {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<BalanceDetailsDTO> = yield call(requestGetTransactionHistory, currentUser.accessToken, currentUser.currentProfile.uuid);
    const { data } = response;
    yield put(setTransactionHistory(data));
  } catch (error: any) {
    yield put(getTransactionHistoryFailed({ message: error?.response?.data?.message }));
  }
}

function* handleGetPaymentMethods() {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<BalanceDetailsDTO> = yield call(requestGetPaymentMethods, currentUser.accessToken, currentUser.currentProfile.uuid);
    const { data } = response;
    yield put(setPaymentMethods(data));
  } catch (error: any) {
    yield put(getPaymentMethodsFailed({ message: error?.response?.data?.message }));
  }
}
function* handleGetPaymentFeesByResident(action: { type: typeof getPaymentFeesByResident; payload: { moneyToSubmit: number; propPayTypeId: number } }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<FeesDTO> = yield call(requestGetPaymentFeesByResident, currentUser.accessToken, currentUser.currentProfile.uuid, action.payload.moneyToSubmit, action.payload.propPayTypeId);
    const { data } = response;
    yield put(setPaymentFeesByResident(data));
  } catch (error: any) {
    yield put(getPaymentMethodsByResidentFailed({ message: error?.response?.data?.message }));
  }
}

function* handleMakeOneTimePayment(action: { type: typeof makeOneTimePayment; payload: CreateOneTimePaymentDto }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<TransactionDTO> = yield call(requestMakeOneTimePayment, currentUser.accessToken, currentUser.currentProfile.uuid, action.payload);
    const { data } = response;
    yield put(setOneTimePaymentResult({ ...data }));
  } catch (error: any) {
    yield put(makeOTPfailed({ message: error?.response?.data?.message }));
  }
}

function* handleGetBankCardType(action: { type: typeof getBankCardType; payload: { cardPrefix: string } }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<BankCardTypeDto> = yield call(requestGetBankCardType as any, currentUser.accessToken, action.payload.cardPrefix);
    const { data } = response;
    yield put(setBankCardType({ ...data }));
  } catch (error: any) {
    yield put(getBankCardTypeFailed({ message: error?.response?.data?.message }));
  }
}

export function* handleCreateBankAccount(action: { type: typeof getCreateBankAccount; payload: CreateBankAccountDTO }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<BankAccountDTO> = yield call(requestCreateBankAccount as any, currentUser.accessToken, action.payload);
    const { data } = response;
    yield put(setCreateBankAccResponse({ ...data, isSuccess: true }));
  } catch (error: any) {
    yield put(createBankAccountFailed({ message: error?.response?.data?.message }));
  }
}

export function* handleSkipAutoPay(action: { type: typeof getSkipAutoPay; payload: UpdateSkipAPDto; autopayUid: string }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<ScheduledAutoPayDto> = yield call(requestSkipAutopay as any, currentUser.accessToken, action.autopayUid, action.payload);
    const { data } = response;
    yield put(setSkipAutoPayResponse({ ...data, isSuccess: true }));
  } catch (error: any) {
    yield put(setSkipAutoPayFailed({ message: error?.response?.data?.message }));
  }
}

export function* handleUpdateBankAccount(action: { type: typeof getUpdateBankAccount; payload: UpdateBankAccountDTO; bankaccountUuid: string }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<object> = yield call(requestUpdateBankAccount as any, currentUser.accessToken, action.bankaccountUuid, action.payload);
    const { data } = response;
    yield put(setUpdateBankAccResponse({ ...data }));
  } catch (error: any) {
    yield put(updateBankAccountFailed({ message: error?.response?.data?.message }));
  }
}

export function* handleDeleteBankAccount(action: { type: typeof getDeleteBankAccount; bankaccountUuid: string }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<void> = yield call(requestDeleteBankAccount as any, currentUser.accessToken, action.bankaccountUuid);

    if (response.status === 204) {
      yield put(setDeleteBankAccResponse({ status: response.status }));
    }
  } catch (error: any) {
    yield put(deleteBankAccountFailed({ message: error?.response?.data?.message }));
  }
}

export function* handleDeleteBankCard(action: { type: typeof getDeleteBankAccount; bankcardUuid: string }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<void> = yield call(requestDeleteBankCard as any, currentUser.accessToken, action.bankcardUuid);

    if (response.status === 204) {
      yield put(setDeleteBankCardResponse({ status: response.status }));
    }
  } catch (error: any) {
    yield put(deleteBankCardFailed({ message: error?.response?.data?.message }));
  }
}
export function* handleUpdateBankCard(action: { type: typeof getUpdateBankCard; payload: UpdateBankCardDTO; bankcardUuid: string }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<BankCardDTO> = yield call(requestUpdateBankCard as any, currentUser.accessToken, action.bankcardUuid, action.payload);
    const { data } = response;
    yield put(setUpdateBankCardResponse({ ...data }));
  } catch (error: any) {
    yield put(updateBankCardFailed({ message: error?.response?.data?.message }));
  }
}

export function* handleCreateBankCard(action: { type: typeof getCreateBankCard; payload: CreateBankCardDTO }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<BankCardDTO> = yield call(requestCreateCardAccount as any, currentUser.accessToken, action.payload);
    const { data } = response;
    yield put(setCreateBankCardResponse({ ...data }));
  } catch (error: any) {
    yield put(createCreateBankCardFailed({ message: error?.response?.data?.message }));
  }
}

export function* handlegetPaymentConfigs() {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<PaymentsConfigDto> = yield call(requestgetPaymentConfigs, currentUser.accessToken, currentUser.currentProfile.uuid);
    const { data } = response;
    yield put(setgetPaymentConfigs({ ...data }));
  } catch (error: any) {
    getPaymentConfigsFailed({ message: error?.response?.data?.message });
  }
}

export function* handleCreateRecurringPayment(action: { type: typeof getCreateRecurringPayment; payload: CreateScheduledAutoPayDto }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<ScheduledAutoPayDto> = yield call(requestCreateRecurringPayment, currentUser.accessToken, action.payload);
    const { data } = response;

    yield put(setCreateRecurringPaymentResponse({ ...data }));
  } catch (error: any) {
    yield put(getCreateRecurringPaymentFailed({ message: error?.response?.data?.message }));
  }
}

export function* handleGetAutoPays() {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<ScheduledAutoPayDto> = yield call(requestGetAutoPays, currentUser.accessToken);
    const { data } = response;
    yield put(setGetAutoPays(data));
  } catch (error: any) {
    yield put(getAutoPaysFailed({ message: error?.response?.data?.message }));
  }
}

export function* handleReplaceAutoPay(action: { type: typeof getReplaceAutoPay; payload: CreateScheduledAutoPayDto; autopayUid: string }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<ScheduledAutoPayDto> = yield call(requestReplaceAutoPay as any, currentUser.accessToken, action.autopayUid, action.payload);
    const { data } = response;
    yield put(setReplaceAutoPayResponse({ ...data }));
  } catch (error: any) {
    yield put(getReplaceAutoPayFailed({ message: error?.response?.data?.message }));
  }
}

export function* handleCancelAutoPay(action: { type: typeof getCancelAutoPay; autopayUid: string }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<void> = yield call(requestCancelAutoPay as any, currentUser.accessToken, action.autopayUid);

    if (response.status === 204) {
      yield put(setCancelAutoPayResponse({ status: response.status }));
    }
  } catch (error: any) {
    yield put(setCancelAutoPayFailed({ message: error?.response?.data?.message }));
  }
}

export function* handleCancelOTP(action: any) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<void> = yield call(requestCancelOTP, currentUser.accessToken, action.payload.transactionUuid, currentUser.currentProfile.uuid);
    if (response.status === 200) {
      yield put(setCancelOTPResponse({ status: response.status }));
    }
  } catch (error: any) {
    yield put(setCancelOTPFailed({ message: error?.response?.data?.message }));
  }
}

export function* handleRefundOTP(action: any) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<void> = yield call(requestRefundOTP, currentUser.accessToken, action.payload.transactionUuid, currentUser.currentProfile.uuid, action.payload.message);
    if (response.status === 200) {
      yield put(setRefundOTPResponse({ status: response.status }));
    }
  } catch (error: any) {
    yield put(setRefundOTPError({ message: error?.response?.data?.message }));
  }
}

export function* handleCancelPaymentStatus(action: any) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<TransactionDTO> = yield call(requestCancelStatus, currentUser.accessToken, currentUser.currentProfile.uuid, action.payload.transactionUuid);
    if (response.status === 200) {
      yield put(setCancelSatusResponse({ canCancel: response.data.Status === ValidTransactionStatusEnum.Pending }));
    }
  } catch (error: any) {
    yield put(setCancelStatusError({ message: error?.response?.data?.message }));
  }
}

/*
  Alternatively you may use takeLatest.

  Does not allow concurrent fetches of user. If "USER_FETCH_REQUESTED" gets
  dispatched while a fetch is already pending, that pending fetch is cancelled
  and only the latest one will be run.
*/
export function* residentPaymentsSaga() {
  yield takeLatest(getResidentDetails.type, handleGetResidentDetails);
  yield takeLatest(getBalanceDetails.type, handleGetBalanceDetails);
  yield takeLatest(getTransactionHistory.type, handleGetTransactionHistory);
  yield takeLatest(getPaymentMethods.type, handleGetPaymentMethods);
  yield takeLatest(getPaymentFeesByResident.type, handleGetPaymentFeesByResident);
  yield takeLatest(makeOneTimePayment.type, handleMakeOneTimePayment);
  yield takeLatest(getBankCardType.type, handleGetBankCardType);
  yield takeLatest(getCreateBankAccount.type, handleCreateBankAccount);
  yield takeLatest(getCreateBankCard.type, handleCreateBankCard);
  yield takeLatest(getUpdateBankAccount.type, handleUpdateBankAccount);
  yield takeLatest(getUpdateBankCard.type, handleUpdateBankCard);
  yield takeLatest(getDeleteBankAccount.type, handleDeleteBankAccount);
  yield takeLatest(getDeleteBankCard.type, handleDeleteBankCard);
  yield takeLatest(getPaymentConfigs.type, handlegetPaymentConfigs);
  yield takeLatest(getCreateRecurringPayment.type, handleCreateRecurringPayment);
  yield takeLatest(getAutoPays.type, handleGetAutoPays);
  yield takeLatest(getReplaceAutoPay.type, handleReplaceAutoPay);
  yield takeLatest(getSkipAutoPay.type, handleSkipAutoPay);
  yield takeLatest(getCancelAutoPay.type, handleCancelAutoPay);
  yield takeLatest(getCancelOTP.type, handleCancelOTP);
  yield takeLatest(getRefundOTP.type, handleRefundOTP);
  yield takeLatest(getCancelStatus.type, handleCancelPaymentStatus);
  // yield takeLatest(getCompanyDetails.type, handleGetCompanyDetails);
  // yield takeLatest(getPropertyGroupDetails.type, handleGetPropertyGroupDetails);
}

//export default mySaga;
